/* Fill these fields with approved same-origin Shopify CDN URLs when supplied. */
const mediaProductKey=window.HOMAR_PREVIEW_PRODUCT?.key||'serum';
window.HOMAR_SERUM_MEDIA = {
  material: { video: '', poster: window.HOMAR_PRODUCT_ASSETS[mediaProductKey].texture },
  application: { video: '', poster: window.HOMAR_PRODUCT_ASSETS[mediaProductKey].sample }
};
/* Only approved evidence goes here. Empty arrays keep the design-preview state. */
window.HOMAR_SERUM_RESULTS = {
  backgroundVideo: '',
  poster: '',
  cases: [],
  stats: []
};

if(window.HOMAR_STUDIO_MEDIA)Object.keys(window.HOMAR_STUDIO_MEDIA).forEach(key=>Object.assign(window.HOMAR_SERUM_MEDIA[key],window.HOMAR_STUDIO_MEDIA[key]));if(window.HOMAR_STUDIO_RESULTS)Object.assign(window.HOMAR_SERUM_RESULTS,window.HOMAR_STUDIO_RESULTS);
